<template>
  <div class="user-messsage">
      <h2 class="user-title Medium">预订记录</h2>
      <ul class="record-list">
        <li class="record-item" v-for="item in orderList">
          <div class="record-title">
            <span>订单编号：{{item.OrderNo}}</span>
            <p>{{item.CreateTime}}创建</p>
          </div>
          <div class="record-content">
            <div class="record-message">
              <div class="record-left">
                <span>预订人：{{item.GuestName}}</span>
               <el-divider direction="vertical"></el-divider>
               <span>手机号：{{item.Mobile}}</span>
               <el-divider direction="vertical"></el-divider>
               <span>预计{{item.ArriveDate.substring(0,10)}}抵店，{{item.LeaveDate.substring(0,10)}}离店</span>
              </div>
               <div class="record-stauts">{{item.confirmTypeName}}</div>
            </div>
            <div class="record-room"> 
              <div>
                <img :src="item.ImageNameList" alt="" />
                <div>
                  <span class="Medium">{{item.RoomName}}</span>
                  <p>x{{item.ItemQty}}间</p>
                </div>
              </div>
              <span class="price">￥{{item.TotalAmount}}</span>
            </div>
          </div>
        </li>
      </ul>
  </div>
</template>

<script>
import {
  getMemberOrderList,
} from "@/request/order.js";
import { mapGetters } from "vuex";
export default {
  name: "record",
  data() {
    return {
     orderList:[]
    };
  },
  // 过滤器
  filters: {
    
  },
  // 局部注册的组件
  components: {},
  // 计算属性
  computed: {
     ...mapGetters("member", ["Token", "ProfileId", "GuestCName"]),
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    getOrderList(){
      var formData = {
        Id : this.ProfileId
      }
      getMemberOrderList(this.Token,formData).then(res =>{
        if(res.response.Code == 200){
          this.orderList = res.response.MemberorderMains
        }else{
          this.$message.error(res.response.Data);
        }
        
      });
    },
  },
  beforeCreate() {},
  created() {
    this.getOrderList();
  },
  beforeMount() {},
  mounted() {
    
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style scoped>
.record-list{
  width: 100%;
  display: flex;
  flex-direction: column;
}
.record-item{
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
}
.record-title{
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 8px;
}
.record-title span{
  color: #000;
}
.record-title p{
  color: #999999;
}
.record-content{
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #F0F2F5;
  box-sizing: border-box;
  padding: 24px;
}
.record-message{
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}
.record-message .record-stauts{
  font-size: 16px;
  color: #499BFC;
}
.record-room{
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.record-room > div{
  display: flex;
  
}
.record-room > div img{
  width: 130px;
  height: 88px;
  border-radius: 4px;
}
.record-room > div div{
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #333;
}
.record-room > div div span{
  margin-bottom: 10px;
}
.price{
  font-size: 24px;
  color: #FF9500;
}
</style>